import fp from 'lodash/fp'
import { createElement } from 'react'
import { Table } from 'shared/components'

import { TournamentLogoCell } from './components/tournamentLogoCell'
import { TeamCell } from './components/teamCell'
import { CountryCell } from './components/countryCell'
import { Controls } from './components/controls'
import { InwinnableCell } from './components/inwinnableCell'

export const createColumns = ({ onOpenBinaryBetModal }) => [
  {
    Header: 'Tournament',
    id: 'matchName',
    accessor: fp.identity,
    Cell: TournamentLogoCell,
    minWidth: 100,
    width: 100,
  },
  {
    Header: 'Event',
    id: 'event',
    accessor: (row) => {
      // Detect custom event by checking if teamOne and teamTwo are missing
      // or if teamA and teamB are empty strings
      const isCustomEvent = (
        (!row.teamOne && !row.teamTwo) ||
        ((!row.teamA || row.teamA === '') && (!row.teamB || row.teamB === ''))
      );

      if (isCustomEvent) {
        // For custom events, return the event object with a flag
        return {
          isCustomEvent: true,
          event: row
        }
      }

      // For regular events with teams, return both teams
      return {
        isCustomEvent: false,
        teamA: row.teamA,
        teamB: row.teamB,
        teamOneObj: row.teamOne,
        teamTwoObj: row.teamTwo,
        event: row // Include the full event data to access the name field
      }
    },
    Cell: TeamCell,
    minWidth: 500,
    width: 500,
  },
  {
    Header: 'Winner',
    accessor: 'winner',
    minWidth: 250,
    width: 250,
  },
  {
    Header: 'Country',
    id: 'country',
    accessor: fp.identity,
    minWidth: 48,
    width: 48,
    Cell: CountryCell,
  },
  {
    Header: 'Inwinnable',
    accessor: 'inWinnable',
    Cell: InwinnableCell,
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Start date',
    accessor: 'startTime',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'End date',
    accessor: 'endTime',
    Cell: Table.CellRenderers.DateTimeCell,
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Controls',
    id: 'controls',
    minWidth: 220,
    width: 220,
    accessor: (value) => value,
    Cell: (props) =>
      createElement(Controls, { onOpenBinaryBetModal, ...props }),
  },
]
